import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default () => {
    return {
        menuIsOpen: false,
        init() {
            this.$watch('menuIsOpen', value => {
                let classListAction;
                if (true === value) {
                    disableBodyScroll();
                    document.body.classList.add('is-menu');
                } else {
                    enableBodyScroll();
                    document.body.classList.remove('is-menu');
                }
            });
        },
    };
};
